// extracted by mini-css-extract-plugin
export default {"dropdownItem":"DocumentList_dropdownItem__tjNcE"};